// src/components/Header.js
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MenuIcon from "@mui/icons-material/Menu";

const Header = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser && !user) {
      window.location.reload();
    }
  }, [user]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (callback) => {
    handleClose();
    if (callback) callback();
  };

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Logo - Links */}
          <Box
            component={RouterLink}
            to="/"
            sx={{
              textDecoration: "none",
              color: "inherit",
              flexGrow: 0,
              display: "flex",
              alignItems: "center",
              py: { xs: 1 },
            }}
          >
            <img
              src="/hck_logo_x140_minfied.svg"
              alt="Dragons Logo"
              width="68"
              height="50"
              style={{
                height: "50px",
                width: "68px",
                marginRight: "10px",
              }}
            />
          </Box>

          {/* Navigation - Rechts */}
          <Box sx={{ flexGrow: 1 }} />
          {user ? (
            isMobile ? (
              // Mobile Menu for logged-in users
              <Box sx={{ flexGrow: 0 }}>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleMenu}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem
                    component={RouterLink}
                    to="/"
                    onClick={handleClose}
                  >
                    Dashboard
                  </MenuItem>

                  <MenuItem
                    component={RouterLink}
                    to="/info"
                    onClick={handleClose}
                  >
                    Info
                  </MenuItem>

                  <MenuItem
                    component={RouterLink}
                    to="/my-bids"
                    onClick={handleClose}
                  >
                    Meine Gebote
                  </MenuItem>

                  {user?.isAdmin && (
                    <MenuItem
                      component={RouterLink}
                      to="/admin"
                      onClick={handleClose}
                    >
                      Admin
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => handleMenuItemClick(logout)}
                    sx={{ color: "error.main" }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </Box>
            ) : (
              // Desktop navigation for logged-in users
              <Box sx={{ flexGrow: 0, display: "flex", gap: 1 }}>
                <Button color="secondary" component={RouterLink} to="/info">
                  Info
                </Button>
                <Button color="secondary" component={RouterLink} to="/my-bids">
                  Meine Gebote
                </Button>
                {user?.isAdmin && (
                  <Button color="inherit" component={RouterLink} to="/admin">
                    Admin
                  </Button>
                )}
                <Button color="error" onClick={logout}>
                  Logout
                </Button>
              </Box>
            )
          ) : (
            // Login button for non-logged-in users (both mobile and desktop)

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button color="secondary" component={RouterLink} to="/info">
                Info
              </Button>
              <Button color="secondary" component={RouterLink} to="/login">
                Login
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
